module.exports = __webpack_public_path__ + "static/media/review4_guide.b860d50a.png";